import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { Layout } from './Layout';
import { prerenderQueries } from '@/lib/prerenderQueries';

function PrerenderHandoff() {
  const { pathname } = useLocation();
  const client = useQueryClient();
  const keys = prerenderQueries(pathname);
  const fetching = useIsFetching({ predicate: query => keys.some(key => client.getQueryCache().find({ queryKey: key, exact: true }) === query) });
  useEffect(() => {
    const staticContent = document.getElementById('prerender-content');
    const root = document.getElementById('root');
    if (!staticContent || !root) return;
    if (keys.some(key => !client.getQueryState(key) || client.getQueryState(key)?.status === 'pending') || fetching > 0) return;
    root.hidden = false;
    staticContent.remove();
  }, [pathname, fetching, client]);
  return null;
}

export function RouteLoader() {
  return <div role="status" aria-label="Loading page" className="flex min-h-[60vh] items-start justify-center pt-12"><span className="h-5 w-5 animate-spin motion-reduce:animate-none rounded-full border-2 border-muted border-t-primary" /></div>;
}

export function RouteContent({ shared = false }: { shared?: boolean }) {
  const content = <Suspense fallback={<RouteLoader />}><Outlet /><PrerenderHandoff /></Suspense>;
  return shared ? <Layout>{content}</Layout> : content;
}